import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-restricoes-financeiras',
  templateUrl: './consulta-restricoes-financeiras.component.html',
  styleUrls: ['./consulta-restricoes-financeiras.component.scss']
})
export class ConsultaRestricoesFinanceirasComponent implements OnInit {

  title = "RESTRIÇÕES FINANCEIRAS";

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'success';
  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
    this.verificaRegistros();
  }

  verificaRegistros() {
    if(this.consulta.registros.length > 0) {
      this.status = "danger";
    }else {
      this.codigoControle = "SEMREGISTRO_OK";
    }
  }

}
